import React, { useEffect } from 'react'
import { compose } from 'recompose'
import { Container, Grid, Paper } from '@material-ui/core'
import Warning from '@material-ui/icons/Warning'
import Typography from '@material-ui/core/Typography'
import Button from '../../../components/Button'
import StyledWrapper from '../../../components/StyledWrapper'
import { withRouter } from 'react-router'
import { injectIntl, FormattedDate } from 'react-intl'
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

import { connect } from 'react-redux'
import Logo from '../../../assets/logo'
import history from '../../../utilties/history'

import { fetchTerm } from '../../../redux/actions'
import { termSelector } from '../../../redux/selectors'

const Term = ({
	intl,
	match,
    term,
    loadTerm
}) => {

	useEffect(() => {
		if (match.params.termId) {
            loadTerm(match.params.termId)
        }
    }, [match.params.termId])

	return (
		<StyledWrapper hideMenu={true}>
			{
				term &&
				<Container maxWidth="lg">
					<Paper style={{  margin: '2em auto 0 auto', padding: '4rem' }} elevation={2}>
						
						<Grid item xs={12} style={{ paddingBottom: '30px' }} data-print="none">
							<Button
								textId='app.error.button'
								style={{ color: '#000'}}
								variant='text'
								color='primary'
								type='submit'
								startIcon={<ArrowBackIcon style={{ fontSize: '24px', paddingRight: '10px' }} />}
								data-testid="consent-link-back"
								onClick={() => {
									history.push(`/`);
								}}
							/>
						</Grid>

						<Grid item style={{ paddingBottom: '20px', textAlign: 'center' }}>
							<Logo />
						</Grid>
						
						<Grid container spacing={2} style={{ display: 'block' }}>
							<Grid item style={{ textAlign: 'right' }}>
								<Typography
									variant='subtitle2'
									style={{ color: '#000', margin: '0 0 20px 0' }}>
									<span>{intl.formatMessage({ id: 'app.terms.signed' })}&nbsp;</span>
									<FormattedDate value={term.acceptedOn} year="numeric" month="long" day="2-digit" />
								</Typography>
							</Grid>
							<Grid item style={{ borderLeft: '5px solid #transparent', padding: '10px 0 25px' }}>
								<div style={{ color: '#000' }}>
									<Typography data-testid="terms-text" variant='body1'> <div dangerouslySetInnerHTML={{ __html: term.terms ? term.terms : intl.formatMessage({ id: 'app.terms.empty' }) }} /> </Typography>
								</div>
							</Grid>
						</Grid>

						<Grid data-print="none" item style={{ paddingTop: '20px', textAlign: 'center' }}>
							<Button
								textId='app.error.button'
								variant='contained'
								color='primary'
								type='submit'
								onClick={() => {
									history.push(`/`);
								}}
							/>
						</Grid>						
					</Paper>
				</Container>
            }
		</StyledWrapper>
	)
}

const mapStateToProps = (state, ownProps) => ({
    term: termSelector(state)
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    loadTerm: (id) => dispatch(fetchTerm(id))
})

const enhance = compose(
	connect(mapStateToProps, mapDispatchToProps),
	injectIntl,
	withRouter
)

export default enhance(Term)
